import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import UnityPriseRepository from '@/shared/http/repositories/realestate/unitytype'
import Tablepriceacording from '../tablepriceacording/tablepriceacording.vue'
import imageselector from '../imageselector/imageselector.vue'
import priceunityenterpriseRepository from '@/shared/http/repositories/realestate/priceunityenterprise'
import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import VirtualTourentErpriseRepository from '@/shared/http/repositories/realestate/virtualtourenterprise'
import { toast, loading } from '@/shared/utils/UIHelper'
import UnityTypeSelector from '../UnityTypeSelector/UnityTypeSelector.vue'
import Tools from '@/components/tools/Tools.js'

export default {
  props: ['data', 'id'],
  name: 'TablePrice',
  components: {HeadDetailsGama, Tablepriceacording, imageselector, UnityTypeSelector, Tools},
  mounted () {
    this.GetAll()
  },
  data () {
    return {
      dataTable: [],
      tipo: null,
      virtualform: {
        id: null,
        linkTour: null,
        descricaoTour: null,
        unidadetipoid: null
      }
    }
  },
  methods: {
    openunitytypeselector (id) {
      this.$refs.openunitytype.tipoId = id
      this.$refs.openunitytype.show(id)
    },
    openimageselector () {
      this.$refs.imageselectormodal.show()
    },
    GetAll () {
      loading.push()
      UnityPriseRepository.GetAllByEmpreendimento(this.data.id)
        .then(Response => {
          for (let i = 0; i < Response.data.data.length; i++) {
            this.dataTable.push(Response.data.data[i])
          }
          loading.pop()
        })
        .catch(() => {})
    },
    hidemodaladdlink () {
      this.$refs.linkvirtual.hide()
    },
    SaveLinkTour () {
      loading.push()
      VirtualTourentErpriseRepository.SaveLinkTour(this.data.id, this.virtualform)
        .then((Response) => {
          this.hidemodaladdlink()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    getvirtualTour (id) {
      loading.push()
      VirtualTourentErpriseRepository.GetTourVirtualByUnidadeTipoIdAndEmpreendimentoid(this.data.id, id)
        .then((Response) => {
          if (Response.data != null) {
            this.virtualform.linkTour = Response.data.linkTour
            this.virtualform.descricaoTour = Response.data.descricaoTour
            this.virtualform.id = Response.data.id
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    openLinkVirtual (id) {
      this.getvirtualTour(id)
      this.$refs.linkvirtual.show()
      Object.keys(this.virtualform).forEach((Element) => {
        this.virtualform[Element] = null
      })
      this.virtualform.unidadetipoid = id
    },
    GetArquivo (id) {
      loading.push()
      UnityPriseRepository.GetArquivo(id)
        .then(Response => {
          loading.pop()
        })
        .catch(() => {})
    },
    getApartamento () {
      loading.push()
      EnterpriseUnityRepository.GetAllByEmpreendimentoId(this.data.id)
        .then(Response => {
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    sendlinktour () {

    },
    imporTable (e) {
      if (e.target.files.length === 0) return
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('Excel', e.target.files[0])
      loading.push()
      priceunityenterpriseRepository.ImportableByEmpreendimento(this.data.id, data, conf)
        .then(Response => {
          this.getApartamento()
          this.dataTable = []
          this.GetAll()
          toast.success('Excel importado com sucesso!!', 'Excel')
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.error('Formato invalido!!', 'Excel')
        })
    },
    openFiles () {
      document.getElementById('impor-ex-price').click()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/tableprice/tableprice.js